import {
  Wifi, Flame, Utensils, Car, Waves, Tv, Baby, Trees, WashingMachine,
  Wind, Coffee, Dog, Home, Bath, Bed, Users, Snowflake, ParkingCircle, Sparkles,
} from "lucide-react";

const MAP = {
  wifi: Wifi,
  flame: Flame,
  utensils: Utensils,
  car: Car,
  waves: Waves,
  tv: Tv,
  baby: Baby,
  trees: Trees,
  "washing-machine": WashingMachine,
  wind: Wind,
  coffee: Coffee,
  dog: Dog,
  home: Home,
  bath: Bath,
  bed: Bed,
  users: Users,
  snowflake: Snowflake,
  parking: ParkingCircle,
};

export function AmenityIcon({ name, className }) {
  const Icon = MAP[name] || Sparkles;
  return <Icon className={className} strokeWidth={1.5} />;
}
